<script>
import { mapActions, mapGetters } from 'vuex';
import snackbarMixin from '@/mixins/snackbar';
import downloader from '@/mixins/downloader';

export default {
  name: 'TomListItem',
  mixins: [downloader, snackbarMixin],
  props: {
    tom: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
  methods: {
    ...mapActions('tomList', { fetchData: 'fetchTomList' }),
    ...mapActions('tomList', ['downloadReport']),
    onDelete() {
      this.$emit('delete', this.tom);
    },
    _downloadReport() {
      return this.downloadReport(this.tom.id)
        .then((response) => {
          this.getDownloadContent(response, 'tom_report.pdf');
        }).catch((error) => {
          console.log(`Fehler: ${error.response}`);
          this.showErrorMessage('Beim Erstellen des Berichts ist ein Fehler aufgetreten.');
        });
    },
  },
};
</script>

<template>
  <tr>
    <td><router-link :to="`/tom/show/${tom.id}`">{{ tom.name }}</router-link></td>
    <td>{{ tom.responsibleUser ? tom.responsibleUser.username : null }}</td>
    <td>{{ tom.examState ? tom.examState.name : null }}</td>
    <td>
      <v-tooltip bottom>
        <v-btn v-if="auth.hasDownloadRights"
               @click.native="_downloadReport" flat icon slot="activator">
          <v-icon small>cloud_download</v-icon>
        </v-btn>
        <span>Bericht herunterladen</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn v-if="auth.hasDeleteRights"
               @click.native="onDelete" flat icon slot="activator" :disabled="tom.isDelete">
          <v-icon small>delete</v-icon>
        </v-btn>
        <span>Löschen</span>
      </v-tooltip>
    </td>
  </tr>
</template>
